import { loadAndAddImage } from '../image_helpers';

const chevronImageId = 'chevron';
const chevronImageSrc = `https://cdn-assets.alltrails.com/assets/icons/maps/chevron@2x.png`;

const addChevronImagesToMap = map => {
  return loadAndAddImage(map, chevronImageId, chevronImageSrc, {
    pixelRatio: 2
  });
};

const createChevronLayer = (id, sourceId) => {
  return {
    id,
    type: 'symbol',
    source: sourceId,
    layout: {
      'icon-allow-overlap': true,
      'icon-ignore-placement': true,
      'icon-image': ['image', chevronImageId],
      'icon-rotate': 90,
      'symbol-placement': 'line',
      'symbol-spacing': 50
    },
    paint: {}
  };
};

export { addChevronImagesToMap, createChevronLayer };
